import { formatPrice } from '@/entities/product'

export const getInstalmentPayPrice = (price: number, term: number) => `от ${formatPrice(price / term)}/мес.`
